import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const ScrapMaterial = ({ btn }) => {
  const singlePropertyInfo = (
    <>
      <p>
        The <strong>Single Property Platform</strong> allows users to showcase
        and advertise a <strong>single property</strong> for sale.
      </p>
      <p>
        On this platform, individuals can promote their personal property
        assets—such as <strong>land, houses, flats,</strong> or{" "}
        <strong>shops</strong>—directly to potential buyers. This marketplace
        supports both <strong>Consumer-to-Consumer (C2C)</strong> and{" "}
        <strong>Consumer-to-Business (C2B)</strong> transactions.
      </p>
      <p>
        The <strong>Single Property Platform</strong> provides a{" "}
        <strong>simple and effective way</strong> for property owners to reach
        interested buyers without creating a business or property shop, making
        property selling more <strong>accessible and transparent</strong>.
      </p>
      <a href="https://www.youtube.com" target="_blank">
        <strong>
          Click here to see how to Explore the Personal Properties
        </strong>
      </a>
    </>
  );

  return (
    <div>
      <Row className="set-one">
        <Col lg="12">
          {/* CardNav displays title + full single property info */}
          <CardNav
            Header="Personal Property"
            myid={1}
            myinfo={singlePropertyInfo}
          />

          {/* BoxData for Single Property */}
          <Card className="shadow-main mt-2">
            <BoxData
              Title="For Rent or  Sale"
              Butonn={btn}
              imgg={images.Businessimage}
              url="/buy-single-property"
              link="/buy-single-property"
              ms="twentythree-element"
              buy="twenty"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ScrapMaterial;
